export default __webpack_public_path__ + "assets/images/fairness-4db689b0676b377aa814ccfd3ac257a5.svg";